/*
 * ===== assets/predictive-search.js =====
 * AJAX 預測搜尋控制器
 */

(function () {
  'use strict';

  var triggerBtn = document.getElementById('bh-search-trigger');
  var searchBar = document.getElementById('bh-header-search-bar');
  var closeBtn = document.getElementById('bh-search-close');
  var overlay = document.getElementById('bh-search-overlay');
  var input = document.getElementById('bh-search-input');
  var resultsDiv = document.getElementById('predictive-search-results');

  if (!searchBar || !input || !resultsDiv) return;

  var debounceTimeout = null;

  /* ---------- Open / Close ---------- */
  function openSearch() {
    searchBar.setAttribute('aria-hidden', 'false');
    searchBar.classList.add('is-active');
    if (overlay) {
      overlay.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-active');
    }
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      input.focus();
    }, 100);
  }

  function closeSearch() {
    searchBar.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    setTimeout(function () {
      searchBar.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      // 清空搜尋內容與結果
      input.value = '';
      resultsDiv.innerHTML = '';
      resultsDiv.style.display = 'none';
    }, 300);
  }

  if (triggerBtn) triggerBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (overlay) overlay.addEventListener('click', closeSearch);

  // ESC 鍵關閉
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
    }
  });

  /* ---------- Predictive Search Request ---------- */
  function fetchSearchResults(query) {
    if (!query) {
      resultsDiv.innerHTML = '';
      resultsDiv.style.display = 'none';
      return;
    }

    // Append * to terms for prefix search matching
    var terms = query.trim().split(/\s+/).filter(Boolean);
    var searchTerms = terms.map(function (t) { return t + '*'; }).join(' ');

    var searchUrl = input.getAttribute('data-search-url') || '/search';
    var url = searchUrl + '?q=' + encodeURIComponent(searchTerms) + '&type=product&view=ajax';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Search request failed');
        return res.json();
      })
      .then(function (data) {
        var products = data.results || [];
        renderSearchResults(products, query);
      })
      .catch(function () {
        resultsDiv.innerHTML = '<div class="predictive-search-error">搜尋失敗，請稍後再試。</div>';
        resultsDiv.style.display = 'block';
      });
  }

  /* ---------- Render Search Results ---------- */
  function renderSearchResults(products, query) {
    if (!products || products.length === 0) {
      resultsDiv.innerHTML = '<div class="predictive-search-empty">找不到與 "' + escapeHtml(query) + '" 相關的商品</div>';
      resultsDiv.style.display = 'block';
      return;
    }

    var html = '<ul class="predictive-search-list" role="listbox">';
    products.forEach(function (product) {
      var priceHtml = product.compare_at_price 
        ? '<span class="predictive-search-item-price-compare">' + product.compare_at_price + '</span> <span class="predictive-search-item-price">' + product.price + '</span>'
        : '<span class="predictive-search-item-price">' + product.price + '</span>';

      html += '<li class="predictive-search-item" role="option">';
      html += '  <a href="' + product.url + '" class="predictive-search-item-link">';
      if (product.image) {
        html += '    <div class="predictive-search-item-img">';
        html += '      <img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" width="40" height="40" loading="lazy">';
        html += '    </div>';
      }
      html += '    <div class="predictive-search-item-info">';
      html += '      <p class="predictive-search-item-title">' + highlightMatch(product.title, query) + '</p>';
      html += '      <p class="predictive-search-item-price-row">' + priceHtml + '</p>';
      html += '    </div>';
      html += '  </a>';
      html += '</li>';
    });
    html += '</ul>';

    // 更多結果連結
    var searchUrl = input.getAttribute('data-search-url') || '/search';
    html += '<div class="predictive-search-view-all">';
    html += '  <a href="' + searchUrl + '?q=' + encodeURIComponent(query) + '&type=product" class="predictive-search-view-all-link">檢視所有結果 &rarr;</a>';
    html += '</div>';

    resultsDiv.innerHTML = html;
    resultsDiv.style.display = 'block';
  }

  /* ---------- Utilities ---------- */
  function escapeHtml(string) {
    return String(string).replace(/[&<>"']/g, function (s) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s];
    });
  }

  function highlightMatch(title, query) {
    var escapedQuery = query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    var regex = new RegExp('(' + escapedQuery + ')', 'gi');
    return title.replace(regex, '<span class="predictive-search-highlight">$1</span>');
  }

  /* ---------- Input Listener ---------- */
  input.addEventListener('input', function () {
    var val = input.value.trim();
    
    if (debounceTimeout) clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(function () {
      fetchSearchResults(val);
    }, 250);
  });

})();
